// extracted by mini-css-extract-plugin
export var component = "ArticleTerms-module--component--Q2Uga";
export var link = "ArticleTerms-module--link--p+nWD";
export var show = "ArticleTerms-module--show--FUu9l";
export var tag = "ArticleTerms-module--tag--abytn";
export var term = "ArticleTerms-module--term--9Mnvd";
export var terms = "ArticleTerms-module--terms--KO4G9";